import { render } from "./CreateCollaboratorModal.vue?vue&type=template&id=158f7b96&scoped=true"
import script from "./CreateCollaboratorModal.vue?vue&type=script&lang=js"
export * from "./CreateCollaboratorModal.vue?vue&type=script&lang=js"

import "./CreateCollaboratorModal.vue?vue&type=style&index=0&id=158f7b96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158f7b96"]])

export default __exports__